import { Box, Typography } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { CSSProperties } from 'react';

interface CodeSnippetViewProps {
  id?: string;
  title?: string;
  value: string;
}

type CodeTypographyTheme = Theme & {
  typography: Theme['typography'] & {
    code?: CSSProperties;
  };
};

const snippetCodeSx = (theme: Theme) => ({
  ...((theme as CodeTypographyTheme).typography.code ?? {}),
  display: 'block',
  fontSize: theme.typography.pxToRem(13),
  lineHeight: 1.45,
  maxWidth: '100%',
  overflowWrap: 'anywhere' as const,
  whiteSpace: 'pre-wrap' as const,
  wordBreak: 'break-word' as const,
});

const CodeSnippetView = ({ id, title, value }: CodeSnippetViewProps) => {
  return (
    <Box id={id ?? title} p={1} width={'100%'} minWidth={0}>
      <Typography component="pre" sx={snippetCodeSx}>
        {value}
      </Typography>
    </Box>
  );
};

export default CodeSnippetView;
